import React from 'react';

const SignupEnd = ({ prevStep, nextStep, setStep, apartment, handleChange, values, focusedTitleRef }) => {

    const Back = e => {
        e.preventDefault();
        setStep(0);
    }

    return (
        <section>
			<div className="article-categories">
				<a href={`/wohnung/?id=${apartment.apartmentId}`} className="article-category">{apartment.title}</a>
			</div>
			<h1 ref={focusedTitleRef} tabIndex="-1"><span>Vielen Dank</span></h1>
			{values.gwgMember === "yes" ? (
				<>
					<p>Wir haben Ihre Angaben erhalten. Wohnen Sie bereits bei der GWG, nehmen Sie automatisch am
						Besichtigungstermin teil. In Kürze erhalten Sie von uns eine automatische E-Mail-Bestätigung
						mit Ihren Angaben.</p>
					<p>Nach dem Zuteilen der Besichtigungstermine erhalten Sie von uns die definitive
						Terminbestätigung.</p>
					<p>Ihr GWG-Team</p>
				</>
			) : (
				<>
					<p>Wir haben Ihre Angaben erhalten. Sie nehmen an der Auslosung für einen
						Wohnungsbesichtigungstermin teil. In Kürze erhalten Sie von uns eine automatische
						E-Mail-Bestätigung mit Ihren Angaben.</p>
					<p>Nach der Auslosung informieren wir Sie, ob Sie an der Besichtigung dabei sind oder
						nicht.</p>
					<p>Ihr GWG-Team</p>
				</>
			)}
        </section>
    )
}

export default SignupEnd
